import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_NAME =
	'AttributeHistoryRuleEditor';
export const ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type AttributeHistoryRuleEditorClassSlot =
	(typeof ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_SLOTS)[number];

export interface AttributeHistoryRuleEditorClasses {
	root: string;
}

export type AttributeHistoryRuleEditorClassKey =
	keyof AttributeHistoryRuleEditorClasses;

export const getAttributeHistoryRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_NAME, slot);

export const attributeHistoryRuleEditorClasses: AttributeHistoryRuleEditorClasses =
	generateUtilityClasses(ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_NAME, ['root']);

export default attributeHistoryRuleEditorClasses;
